// component
import { ArrowRightIcon } from "../../kits/Icons/Icons";
import CustomButton from "../../kits/custom-button/CustomButton";
import ShoppingCartItemContext from "../../../context/ShoppingCart/ShoppingCartItemContext";
import BasketItems from "./BasketItems";
import Drawer from "../../drawer/Drawer";
import useAxios from "../../../services/useAxios";
// style
import "./ShoppingBaskes.scss";
import imgsabadi from "../../../assets/images/defaultCover/defaultCoverProduct.png";
import img from "../../../assets/images/img1.jpg";
// react imports
import {useState, useContext, useEffect} from "react";
import { NavLink } from "react-router-dom";
import {getBoxByPosition} from "../../../utilities/apiTools";
import BoxSlider from "../slider/BoxSlider";

export default function ShoppingBaskets() {
  const { shoppingList, updateShoppingList } = useContext(
    ShoppingCartItemContext
  );
  const [isOpen, setIsOpen] = useState(false);
  console.log("shoppingList", shoppingList);
  const [basketData, setBasketData] = useState([
    {
      title: "نام محصول خریداری  شده",
      count: "3",
      price: "12000",
      img: img,
      imgdefult: imgsabadi,
    },
    {
      title: "نام محصول خریداری  شده",
      count: "3",
      price: "12000",
      img: img,
      imgdefult: imgsabadi,
    },
    {
      title: "نام محصول خریداری  شده",
      count: "3",
      price: "12000",
      img: "",
      imgdefult: imgsabadi,
    },
    {
      title: "نام محصول خریداری  شده",
      count: "3",
      price: "12000",
      // img: img,
      imgdefult: imgsabadi,
    },
    {
      title: "نام محصول خریداری  شده",
      count: "3",
      price: "12000",
      img: img,
      imgdefult: imgsabadi,
    },
    {
      title: "نام محصول خریداری  شده",
      count: "3",
      price: "12000",
      // img: "",
      imgdefult: imgsabadi,
    },
    {
      title: "نام محصول خریداری  شده",
      count: "3",
      price: "12000",
      img: img,
      imgdefult: imgsabadi,
    },
    {
      title: "نام محصول خریداری  شده",
      count: "3",
      price: "12000",
      img: img,
      imgdefult: imgsabadi,
    },
  ]);

  console.log("shoppingList", shoppingList);

  const [boxBanners, setBoxBanners] = useState({})

  useEffect(() => {
    const loadBanner = async () => setBoxBanners(await getBoxByPosition("b5"));
    loadBanner();
  }, []);

  return (
    <div className="parent-basket">
      <div className="d-flex mr-t-10 pd-t-12 pd-b-12 pd-l-20  pd-r-20">
        <div
          style={{ cursor: "pointer" }}
          onClick={() => {
            window.history.back();
          }}
        >
          <ArrowRightIcon></ArrowRightIcon>
        </div>

        <div className="mr-r-8 title title-h3-b  ">سبدهای خرید</div>
      </div>
      {shoppingList.length > 1 && (
        <div className="pd-x-20 title-h3-b mr-t-8">
          {shoppingList.length} سبد خرید
        </div>
      )}
      {shoppingList.length > 0 ? (
        <>
          {(boxBanners.b5) && (
              <div className="pd-x-20">
                <BoxSlider banner={boxBanners.b5}/>
              </div>
          )}

          {[...shoppingList].reverse()?.map((val, ind) => {
            return (
              <>
                <div key={`basket_${ind}`}>
                  <BasketItems
                    supplierinfo={val.supplier_info}
                    items={val.items.reverse()}
                    user_Address={val.user_Address}
                    index={ind}
                    val={shoppingList}
                    updateShoppingList={updateShoppingList}
                  ></BasketItems>
                </div>
              </>
            );
          })}
        </>
      ) : (
        <div className="text-center d-flex flex-column align-items-center justify-content-center flex-grow-1 h-100">
          {/* <div className="box "></div> */}
          <div className="title-h3-m mr-t-24">سبد خرید شما خالی است!</div>
          <div className="message mr-t-8 desc-c-l">
            می‌توانید برای مشاهده محصولات بیشتر به صفحه زیر بروید:
          </div>

          <div className="mr-t-24">
            <NavLink to={"/"} className="text-decoration-none">
              <CustomButton
                className="mr-t-20 mr-b-10 pd-x-16 pd-y-12 text-decoration-none"
                buttonStyle="primary"
                state="default"
                size="medium"
              >
                <span className="title-h4-m">فروشگاهای اطراف من</span>
              </CustomButton>
            </NavLink>
          </div>
        </div>
      )}
    </div>
  );
}
